<div class="row justify-between items-center">
  <div class="mat-card-title-2">{{data.title | translate}}</div>
  <button mat-icon-button cursor-pointer mat-button mat-dialog-close><mat-icon>close</mat-icon></button>
</div>
<div class="relative mb-16">
  <ng-container *ngIf="data.withLoading && (loading$ | async)">
    <div [ngClass]="data.modalComponentData?.loadingClass" class="p-32 my-48">
      <div class="flex-col-container justify-center items-center spiner">
        <mat-spinner [diameter]="70" style="margin: 30px 0 15px 0"></mat-spinner>
        <span class="fs-20 mt-8">{{ (data.modalComponentData?.loaderTitle || 'MODAL_WITHDRAW.LOADER.TITLE') | translate }}</span>
        <p class="text-light-gray fs-14">{{ (data.modalComponentData?.loaderSubtitle || 'MODAL_WITHDRAW.LOADER.SUBTITLE') | translate }}</p>
      </div>
    </div>
  </ng-container>

  <div [style.display]="(data.withLoading && (loading$ | async)) ? 'none' : 'block'">
    <span *ngIf="data.subtitle">{{data.subtitle | translate}}</span>

    <mat-dialog-content>
      <ng-container *ngIf="data.dialogContent">
        <ng-container *ngTemplateOutlet="data.dialogContent"> </ng-container>
      </ng-container>
      <ng-container *ngIf="data.dialogComponent">
        <ng-container *ngComponentOutlet="data.dialogComponent; injector: componentInjector"></ng-container>
      </ng-container>
    </mat-dialog-content>

    <mat-dialog-actions
      *ngIf="!data.hideButtonFooter"
      class="row"
      [ngClass]="data.declineButtonTitle && data.acceptButtonTitle
  ? 'justify-between'
  : 'justify-center'">
      <app-button
        class="basis-48"
        *ngIf="data.declineButtonTitle"
        mat-dialog-close
        [label]="data.declineButtonTitle | translate"></app-button>
      <app-button
        class="basis-48"
        theme="purple"
        (click)="onAccepted()"
        [label]="(data.acceptButtonTitle || '') | translate"
        [buttonDisabled]="acceptButtonTitleDisabled"></app-button>
    </mat-dialog-actions>
  </div>
</div>
